<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>
<style src="./job.scss" lang="scss"></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'JobPage',
    metaInfo() {
      return {
        title: this.$t('meta.job.title', { name: this.job.title }),
      }
    },
    computed: {
      ...mapState('jobs', [
        'job',
        'jobPagination',
      ]),
      ...mapState('auth', ['settings']),
    },
    watch: {
      '$route.params.id'(value) {
        this.getJob(value)
      },
    },
    created() {
      this.getJob(this.$route.params.id).then(_ => {})
    },
    destroyed() {
      this.clearJob()
    },
    methods: {
      ...mapActions('jobs', [
        'getJob',
        'clearJob',
      ]),
      applyJob() {
        const receiver = this.settings.jobs_option && this.settings.jobs_option.receiver_email || '',
          subject = this.$t('job.apply_job.subject'),
          message = this.$t('job.apply_job.message')
        window.open(`mailto:${receiver}?subject=${subject}&body=${message}`, subject)
      },
      formatJobDate(jobDate) {
        return moment(jobDate, 'DD.MM.YYYY').calendar()
      },
    },
  }
</script>
